const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: [],
	listaDespesa: [],
	listaRepresentante:[],
	filtro: {
		dataInicial: null,
		dataFinal: null,
	},
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case 'PAGAMENTO_COMISSAO_MODO_TELA':
			return {
				...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'PAGAMENTO_COMISSAO_LISTADO':
			return {
				...state,
				lista: action.payload.data
			};

		case 'PAGAMENTO_COMISSAO_SET_AGUARDANDO':
			return {
				...state,
				aguardando: action.payload
			};

		case 'PAGAMENTO_COMISSAO_REPRESENTANTE_LISTADO':
			return {
				...state,
				listaRepresentante: action.payload.data
			};

		case 'PAGAMENTO_COMISSAO_FILTRO':
			return { ...state, filtro: action.payload };

		default:
			return state;
	}
}